import React, { useEffect, useReducer, useState } from 'react'
import ClockContext from '../../context/clockContext'
import NotficationContext, {
  INotification,
} from '../../context/notficationContext'
import Notifications from '../../ui/notifications/notifications'
import Footer from '../../ui/Footer/footer'
// import SideDrawer from "../../component/navigation/sideDrawer/sideDrawer"
import { Helmet } from 'react-helmet'
import UMath from '../../utils/umath'
import './layout.css'

export interface ILayoutProps {
  title?: string
  footer?: boolean
  navbar?: boolean
  children?: any
}

const Layout = (props: ILayoutProps) => {
  const [notifications, setNotifications] = useState<INotification[]>([])
  interface ClockAction {
    type: string
  }
  interface ClockState {
    time: number[]
  }
  const clockReducer = (state: ClockState, action: ClockAction) => {
    let newState
    switch (action.type) {
      case 'update':
        newState = { time: UMath.clock() }
        break
      default:
        newState = state
    }
    return newState
  }
  const [state, dispatch] = useReducer(clockReducer, {
    time: UMath.clock(),
  })
  useEffect(() => {
    const clockLoop = setInterval(() => {
      dispatch({ type: 'update' })
    }, 1000)
    return () => {
      clearInterval(clockLoop)
    }
  }, [])
  return (
    <ClockContext.Provider value={state ? state : { time: UMath.clock() }}>
      <NotficationContext.Provider value={{ notifications, setNotifications }}>
        <Helmet>
          <meta charSet="utf-8" />
          <title>{props.title}</title>
        </Helmet>
        {/* {props.navbar ?
                    <Navbar {...props}/>
                    :
                    null
                }
                {props.sidedrawer ?
                    <SideDrawer/>
                    :
                    null
                } */}
        {notifications ? <Notifications notifications={notifications} /> : null}
        {props.children}
        {props.footer ? <Footer /> : null}
      </NotficationContext.Provider>
    </ClockContext.Provider>
  )
}

export default Layout
